<template>
  <div class="checkout mediumRoundAngles">
    <!--<loadingLogo v-if="!checkoutLoaded"></loadingLogo>-->
    <div class="left">
      <stepper class="stepper"
               :steps="steps"
               :currentStep="currentStep"
      >
      </stepper>
      <div class="checkout-container" :style="{'min-width': checkoutWidth}">

      </div>
      <span v-if="checkoutLoaded" class="cgv-text">En poursuivant vous reconnaissez avoir pris connaissance et accepté les <router-link :to="{name: 'cgv'}">conditions générales de ventes</router-link></span>
    </div>

    <div class="recap">
      <h2 :class="[isMobile ? 'display-none' : '']">Mon plan</h2>
      <div class="premiumAccess" :class="[isMobile ? 'display-none' : '']">
        <ul>
          <li>Sessions illimitées</li>
          <li>+ de vocabulaire</li>
          <li>Questionnaires de compréhension</li>
          <li>Jeu du pendu</li>
        </ul>
        <strong>=> Je progresse plus vite !</strong>

      </div>
      <hr :class="[isMobile ? 'display-none' : '']">
      <div class="price smallPaddingRound smallMargin">
        <div class="recap-line" :class="[isMobile ? 'price' : '']">
          <div class="smallPaddingRound">Durée</div>
          <div class="smallPaddingRound">{{ plan.duration }} mois</div>
        </div>
        <div class="recap-line" :class="[isMobile ? 'price' : '']">
          <div class="smallPaddingRound"><big><strong>Total net :</strong></big></div>
          <div class="smallPaddingRound"><strong>{{ plan.price }} €</strong></div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "inlineCheckout",
  components: {
    stepper: () => import(/* webpackPrefetch: true */ '@/components/stepper.vue')
  },

  props: {
    plan: Object,
    paddle: Object,
    profile: Object,
    checkoutLoaded: Boolean,
    currentStep: Number
  },

  created() {
    this.defineCheckout();


  },

  mounted() {
    this.paddle.Checkout.open({
      method: 'inline',
      frameTarget: 'checkout-container',
      frameInitialHeight: 416,
      frameStyle: 'width:100%; min-width:' + this.checkoutWidth + '; background-color: transparent; border: none;',
      product: this.checkoutParams.productId,
      locale: 'fr',
      /*coupon: "EARLYBIRD",*/
      passthrough: "{\"user_id\": \"" + this.profile.sub + "\", \"billing_type\": "+ this.plan.duration +"}",
      email: this.profile.email,
      //message: 'Bienvenu(e) sur Learn & Watch !',
      successCallback: () => {
        if(!this.$isDebug) {
          fbq('track', 'Subscribe', {value: this.checkoutParams.value, currency: 'EUR', predicted_ltv: this.checkoutParams.value});
        }
        this.$emit('sub');
      }
    })
  },

  methods: {
    defineCheckout: function() {
      if(this.plan.duration === 1) {
        this.checkoutParams.productId = 742953;
        this.checkoutParams.monthNb = 1;
        this.checkoutParams.value = 9.73
      }
      else if(this.plan.duration === 3) {
        this.checkoutParams.productId = 742952;
        this.checkoutParams.monthNb = 3;
        this.checkoutParams.value = 23.05
      }
      else if(this.plan.duration === 6) {
        this.checkoutParams.productId = 742951;
        this.checkoutParams.monthNb = 6;
        this.checkoutParams.value = 33.00
      }
      else if(this.plan.duration === 12) {
        this.checkoutParams.productId = 742950;
        this.checkoutParams.monthNb = 12;
        this.checkoutParams.value = 46.55
      }
    }
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    checkoutWidth: function() {
      if(this.isMobile) {
        return '25%'
      }
      else return '75%'
    }
  },

  data() {
    return {
      checkoutParams: {
        productId: 0,
        monthNb: 0,
        value: '00.00',
      },
      country: 'FR',
      postCode: 67150,
      steps: ['Localisation', 'Moyen de paiement', 'Paiement'],
    }
  }
}
</script>

<style scoped>
hr {
  display: block;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  width: available;
  margin-left: 0px;
  margin-right: 0px;
  border-style: inset;
  border-width: 1px;
}

  .checkout{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
  }

  .left {
    width: calc(100% - 1vw);
    display: flex;
    flex-direction: column;
    padding: 0.5vw;
    height: calc(100% - 1vw);
    overflow: auto;
  }

  .cgv-text {
    text-align: center;
    font-size: 12px;
  }

  .cgv-text a {
    color: #737373;
  }

  .stepper {
    width: 100%;
  }

  .recap{
    height: fit-content;
    display: flex;
    flex-direction: column;
    margin-left: auto;
    color: var(--goalBackgroundColor3);
    background-color: var(--navBackgroundColor);
    padding: 1vw;
    border-radius: 2vw;
  }

  ul{
    list-style-type: square;
    list-style-position: outside;

  }

  .li-last{
    list-style-type: none;
  }

  .premiumAccess{
    display: flex;
    flex-direction: column;
  }

  .recap-line{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .total{
    font-weight: bold;
  }

  @media screen and (max-device-width: 767px) {
    hr {
      display: block;
      margin-top: 0px;
      margin-bottom: 0px;
      height: 100%;
      margin-left: 0px;
      margin-right: 0px;
      border-style: inset;
      border-width: 1px;
    }

    .checkout{
      width: 100%;
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-evenly;
      align-items: center;
      --checkoutWidth: 300px;
    }

    .left {
      width: available;
    }

    .recap {
      display: flex;
      width: inherit;
      height: max-content;
      /*display: flex;*/
      flex-direction: row;
      border-left: 0px;
      padding: 0px;
      border-radius: 0;
      background-color: var(--goalBackgroundColor2);
    }

    .display-none{
      display: none
    }

    .recap-line{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    .price {
      width: auto;
      align-self: center;
    }

    .premiumAccess{
      width: max-content;
    }

  }
</style>